export const transform_max_rain_color_bar_image = (img_src) => {
    // 這段 code 因應 webmap_json 暫時只提供舊版的 color bar img 路徑
    // 先暫時使用一個 function 做轉換

    if (!img_src) return undefined;

    const SRC_MAPPING = {
        "/static//images/product/max_rain/P1.png": '/static/UIUX/images/max_rain//P1.png', 
        "/static//images/product/max_rain/P12.png": '/static/UIUX/images/max_rain/P12.png', 
        "/static//images/product/max_rain/P24.png": '/static/UIUX/images/max_rain/P24.png',
    }

    return SRC_MAPPING[img_src] ? SRC_MAPPING[img_src] : img_src
}